import { get } from '@client/lib/request';

export function fetchCategorySubline(gender) {
    return get('/mylounge-api/category-subline', { gender });
}
